export default "__VITE_ASSET__DeadAU8W__"